export const getStationAllowedDomainMessage = (
  allowedEmailDomains: string[],
): string => {
  const allowedDomains = allowedEmailDomains.join(", ");

  return `Diese Station ist nur mit einer E-Mail-Adresse von ${allowedDomains} verfügbar.`;
};
